<template>
  <div class="krSet">
    <el-dialog :title="diagTitle" :visible.sync="diagShow" :close-on-click-modal='false' class="edit_dialog">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <ux-grid :data="editdata" v-loading="loading2" :max-height="500" border fit highlight-current-row style="width: 100%" ref="tableHeight">
              <ux-table-column type="index" width="60" align="center" title="序号"></ux-table-column>
              <ux-table-column align="center" title="水位(m)" field="z" min-width="70">
                <template slot-scope="scope" >
                  <input type="number" class="editInput" v-model="scope.row.z" >
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="库容(万m³)" field="value" min-width="70">
                <template slot-scope="scope" >
                  <input type="number" class="editInput" v-model="scope.row.v">
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="施测时间" field="mstm" min-width="70">
                <template slot-scope="scope">
                  <input type="number" class="editInput" v-model="scope.row.mstm">
                  <!-- <span>{{ !scope.row.mstm ? '-' : scope.row.mstm }}</span> -->
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="点序号" field="ptno" min-width="70">
                <template slot-scope="scope">
                  <input type="number" class="editInput" v-model="scope.row.ptno">
                  <!-- <span>{{ !scope.row.ptno ? '-' : scope.row.ptno }}</span> -->
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="水面面积（10^5m²）" field="wsfa" min-width="110">
                <template slot-scope="scope">
                  <input type="number" class="editInput" v-model="scope.row.wsfa">
                  <!-- <span>{{ !scope.row.wsfa ? '-' : scope.row.wsfa }}</span> -->
                </template>
              </ux-table-column>
            </ux-grid>
          </div>
        </el-col>
      <el-col :span="12" >
        <div class="grid-content bg-purple-light" >
          <div class="chartContainer">
            <div id="storageLine" style="max-height:500px" ref="lineHeight"></div>
          </div>
        </div>
      </el-col>
    </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diagShow = false">取消</el-button>
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import scenceTypes from '@/store/types/scence'
export default {
  // components: { cusMulSelect },
  data () {
    return {
      stcd: '',
      singleData: {},
      name: '类型:',
      choosed: 0,
      loading: false,
      diagShow: false,
      diagTitle: '编辑',
      height: 200,
      loading2: false,
      query: {
        STNM: ''
      },
      waterdata: [],
      spanArr: [],
      editdata: []
    }
  },
  methods: {
    onEdit (row) {
      this.diagTitle = row.stnm + '编辑'
      this.loading2 = true
      this.$store.dispatch(scenceTypes.GET_STORAGE_CURVE, { stationId: row.stationId }).then(data => {
        this.editdata = data.rows
        this.drawStorageLine(data.rows) // 库容曲线
        this.loading2 = false
      })
      this.diagShow = true
    },
    onSave () {
      this.$store.dispatch(scenceTypes.SAVE_STORAGE_CURVE, { rows: this.editdata }).then(data => {
        this.$notify.success({ title: '成功', message: '保存成功。' })
        this.diagShow = false
      })
    },
    getSpanArr (data) {
      this.spanArr = []
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          if (data[i].stnm === data[i - 1].stnm) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 3) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    drawStorageLine (data) {
      let xData = []
      let serData = []
      data.forEach(el => {
        xData.push(el.z)
        serData.push(el.v)
      })
      let arrFirst = []
      let arrFinal = []
      for (let i = 0; i < serData.length; i++) {
        arrFirst = [xData[i], serData[i]]
        arrFinal.push(arrFirst)
      }
      let myChart = this.$echarts.init(document.getElementById('storageLine'))
      myChart.clear()
      myChart.setOption({
        grid: {
          left: '8%',
          right: '7%',
          bottom: '5%',
          top: '6%'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params, ticket, callback) {
            let htmlStr = ''
            for (var i = 0; i < params.length; i++) {
              let param = params[i]
              let value = param.value// y轴值
              let color = param.color// 图例颜色
              let danwei = '万m³'
              if (i === 0) {
                htmlStr += `<div>
                <span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:${color};"></span>
                水位：${param.axisValue}m
              </div>`// x轴
              }
              htmlStr += `<div>
                <span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:${color};"></span>
                库容：${value[1]}${danwei}
              </div>`
            }
            return htmlStr
          }
        },
        xAxis: {
          type: 'value',
          name: ' 水 \n 位 \n(m)',
          min: Math.floor(xData[0]),
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              opacity: 0.5
            }
          },
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '库容(万m³)',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              opacity: 0.5
            }
          },
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          }
        },
        series: [{
          data: arrFinal,
          symbolSize: 0,
          smooth: true,
          type: 'line',
          itemStyle: {
            color: '#87CEEB'
          },
          markLine: {
            symbol: 'none'
          }
        }]
      })
    }
  },
  created () {
  }
}
</script>
<style lang="less" scoped>
.krSet /deep/ .el-dialog {
  width: 70%;
}
.krSet /deep/ .el-dialog__body {
  overflow: hidden !important;
}
/deep/ .el-form{
  width: 100% !important;
}
/deep/.el-form-item {
  width: 50% !important;
  float: left;
}
/deep/ .el-form-item__label{
  width: 100px !important;
}
.skt{
  height: calc(100% - 0px) !important;
}
.tabs{
  margin-bottom: 10px;
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
  .country{
    float: left;
    font-family: Microsoft YaHei UI;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    margin-left: 0.5%;
    cursor: pointer;
    .countryon, .categoryon{
      border-radius: 15px;
      background-color: #fda72c;
      color: #ffffff
    }
    span{
      padding: 4px 15px;
    }
  }
}
.note {
  color: #aaa;
  margin-left: 50px;
}
.app-container{
  width: 100%;
  height: 880px;
  position: relative;
  top: -80px;
  .filter-container {
    width: 100%;
    height: 80px;
    background: #ffffff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
  }
  .el-table{
    background: #ffffff;
    border-radius: 5px;
  }
}
.operation{
  margin: 0!important;
}
.edit_dialog  {
  /deep/ .editInput{
    line-height: 26px;
    width: 100%;
    border: none;
    text-align: center;
    background: rgba(0,0,0,0);
    &:focus{
      outline: none;
    }
  }
}
.chartContainer {
  width: 100%;
  height: 100%;
    #storageLine{
    width: 100%;
    height: 500px;
  }
}

.krSet{
  /deep/ .el-dialog__wrapper{
    .el-dialog{
      margin-top: 10vh!important;
    }
    .el-dialog__footer{
      margin-top: 0!important;
    }
  }
}
  /* 优化表格样式 */
.plTableBox /deep/ .elx-table{
  text-align: center !important;
  font-family: Microsoft YaHei UI !important;
  font-size: 15px !important;
  color: #666 !important;
  .elx-table--header-wrapper thead tr {
    background: #F5F7FA !important;
  }
}
/deep/ .elx-table tr:nth-child(even) {
  background: #eaf1fa !important;
}
</style>
